import { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch } from 'redux';

import { UploadStatus } from '../../../UIPackage/MainModule/components/UploadStatus';
import { IKnmAttachment } from '../../../APIPackage/KnmModule/interfaces/IKnmAttachment';
import { IUploadFile } from '../../../CorePackage/MainModule/interfaces/IUploadFile';
import { useKnmDocumentAttachment } from '../../../KnmPackage/MainModule/hooks/useKnmDocumentAttachment';
import { KnmSignDocumentModal } from '../../../KnmPackage/KnmDocumentsModule/components/KnmSignDocumentModal';
import { Button } from '../../../UIPackage/MainModule/components/Button';
import { FieldBlock } from '../../../UIPackage/FormModule/components/FieldBlock';
import { adminGetFetchSettings } from '../../AdminModule/actions/adminAction';
import { RootActions } from '../../../CorePackage/MainModule/types/RootActions';
import { getAdminFetchSettings } from '../../AdminModule/selectors/adminSelectors';

interface IPassportGroupFileInputProps {
  label: string;
  attachment: IKnmAttachment | undefined;
  setAttachment: (value: IKnmAttachment | undefined) => void;
}

export const PassportGroupFileInput = ({ label, attachment, setAttachment }: IPassportGroupFileInputProps) => {
  const dispatch = useDispatch<Dispatch<RootActions>>();
  const [isShowUploadModal, setIsShowUploadModal] = useState(false);
  const { uploadKnmDocumentAttachment } = useKnmDocumentAttachment();
  const settings = useSelector(getAdminFetchSettings);

  const showedFiles = useMemo((): IUploadFile[] => {
    return attachment
      ? [
          {
            fileId: null,
            fileName: attachment.fileName || '',
            fileSize: attachment.fileSize || 0,
            fileType: attachment.mimeType || '',
            progress: 100,
            success: true,
          },
        ]
      : [];
  }, [attachment]);

  const handleSaveAttachment = useCallback(
    async (document: File, signatureInfo: IKnmAttachment['signatureInfo']) => {
      const uploadedAttachment = await uploadKnmDocumentAttachment(document);
      const newAttachment: IKnmAttachment = {
        ...uploadedAttachment,
        signatureInfo,
        signed: !!signatureInfo?.length,
      };

      setAttachment(newAttachment);
      setIsShowUploadModal(false);
    },
    [uploadKnmDocumentAttachment, setAttachment, setIsShowUploadModal],
  );

  useEffect(() => {
    !settings.length && dispatch(adminGetFetchSettings());
  }, [settings]);

  return (
    <>
      <FieldBlock
        label={label}
        color="black"
        button={
          <Button
            className="shared-btn-add"
            text="Добавить"
            type="button"
            variant="link"
            color="primary"
            onClick={() => setIsShowUploadModal(true)}
            disabled={!!attachment}
          />
        }
      >
        <UploadStatus files={showedFiles} removeFile={() => setAttachment(undefined)} setError={() => {}} />
      </FieldBlock>
      <KnmSignDocumentModal
        isVisibleModal={isShowUploadModal}
        fieldName=""
        onCloseSignModal={() => setIsShowUploadModal(false)}
        onSaveSignedDocument={handleSaveAttachment}
      />
    </>
  );
};
